// libs
import React, { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// components 
// ...
// config & functions 
// ...

function FormModal({setshowformmodalbox, rowdata, token, orginfo}) {

    const [Show, setShow] = useState(false);

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false)
	}

    // Get data from DB - Used for Edit option
    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{'Shipping Details'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                <Col md="12" className="mt-3">
                                    <p className="fs-16rem fw-bold">Order Id: {rowdata?.orderId}</p>
                                </Col>
                                <Col md="6" className="mt-3">
                                    <label className="form-label fs-14rem fw-bold">Shipping Name:</label>
                                    <p className="fs-14rem">{rowdata?.name}</p>
                                </Col>
                                <Col md="6" className="mt-3">
                                    <label className="form-label fs-14rem fw-bold">Shipping Email:</label>
                                    <p className="fs-14rem">{rowdata?.email}</p>
                                </Col>
                                <Col md="6" className="mt-3">
                                    <label className="form-label fs-14rem fw-bold">Shipping Phone No:</label>
                                    <p className="fs-14rem">{rowdata?.phoneNo}</p>
                                </Col>
                                <Col md="12" className="mt-3">
                                    <label className="form-label fs-14rem fw-bold">Shipping Address:</label>
                                    <p className="fs-14rem">{rowdata?.address}</p>
                                </Col>
                                <Col md="6" className="mt-3">
                                    <label className="form-label fs-14rem fw-bold">Shipping State:</label>
                                    <p className="fs-14rem">{rowdata?.state}</p>
                                </Col>
                                <Col md="6" className="mt-3">
                                    <label className="form-label fs-14rem fw-bold">Shipping City:</label>
                                    <p className="fs-14rem">{rowdata?.city}</p>
                                </Col>
                                <Col md="6" className="mt-3">
                                    <label className="form-label fs-14rem fw-bold">Shipping Pincode:</label>
                                    <p className="fs-14rem">{rowdata?.pincode}</p>
                                </Col>
                            </>}
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default FormModal;